import React from "react";

const MitchellGuld = (props) => {
  return (
    <div>
      <div className="flex mt-4">
        <div
          className="gap-2 flex border border-gray-100 px-2 py-3"
          style={{ backgroundColor: props.backgroundColor }}
        >
          <div className="w-full my-auto text-center" style={{ color: props.priceColor }}>
            <p className="mb-0">
              <span className="text-2xl font-[1000]">$4.99</span>
            </p>
          </div>
          <div className="w-full flex">
            <img className="w-20 h-10 m-auto" src={require("../../../assets/instatags.png")} />
          </div>
          <div className="w-full text-center" style={{ color: props.priceColor }}>
            <p className="m-auto text-md font-[1000]">4pk 16oz Cans</p>
          </div>
          <div className="w-full flex">
            <img className="w-20 h-10 m-auto" src={require("../../../assets/instatags.png")} />
          </div>
          <div className="w-full my-auto text-center" style={{ color: props.priceColor }}>
            <p className="mb-0">
              <span className="text-2xl font-[1000]">$4.99</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MitchellGuld;
